export function formatPhoneNumber(phone) {
    if (!phone) return "";

    const digits = String(phone).replace(/\D/g, "");
    const last10 = digits.length > 10 ? digits.slice(-10) : digits;

    if (last10.length !== 10) return phone;

    const code = last10.slice(0, 3);
    const first = last10.slice(3, 6);
    const second = last10.slice(6, 8);
    const third = last10.slice(8, 10);

    return `+7 (${code}) ${first}-${second}-${third}`;
}